/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Stats\Stats.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday December 13th 2023 10:37:00 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Box, Tab, Tabs } from "@mui/material";
import ConnexionComponent from "Content/Connexion/ConnexionComponent/ConnexionComponent";
import translator from "MultiLanguage/TranslationWrapper";
import { indexOf } from "lodash-es";
import { SyntheticEvent, useEffect, useState } from "react";
import Styles from "Content/Stats/Stats.module.css";
import FindUserAdmin from "Content/FindUser/FindUserAdmin";
import SeenCarComponent from "Content/SeenCar/SeenCarComponent";
import { useLoaderData } from "react-router-dom";
import OfferStatsComponent from "Content/Offers/OffersStats/OfferStatsComponent";
import EmailComponent from "Content/Email/EmailComponent/EmailComponent";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    idlabel: string;
    aria: string;
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel"
        hidden={value !== index}
        id={`${other.idlabel}-${index}`}
        aria-labelledby={`${other.aria}-${index}`}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}

type StatsData = {
    order?: string,
    orderby?: string,
    withadmin?: string,
    searchterm?: string,
    tabkey?: string,
    page?: string
}

function Stats() {
    const tabIdx = ["connexion", "seencar", "offer", "email"];
    const loadData: StatsData = useLoaderData() as StatsData;
    const [value, setValue] = useState(loadData.tabkey ? indexOf(tabIdx, loadData.tabkey) : 0);
    const [withAdmin, setWithAdmin] = useState<boolean>(loadData.withadmin === "true" ? true : false);
    const [userID, setUserID] = useState<string | undefined>();
    const [searchTerm, setSearchTerm] = useState<string | undefined>(loadData.searchterm ?? "");
    const [order, setOrder] = useState<string | undefined>(loadData.order ?? "desc");
    const [orderBy, setOrderBy] = useState<string | undefined>(loadData.orderby ?? "week");
    const [page, setPage] = useState(loadData.page ? parseInt(loadData.page) : 1);

    useEffect(() => {
        if (withAdmin !== undefined) {
            const url = window.location;
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("withadmin", withAdmin.toString());
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
        }
    }, [withAdmin]);

    useEffect(() => {
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        if (searchTerm)
            searchParams.set("searchterm", encodeURIComponent(searchTerm.substring(0,3)));
        else
            searchParams.delete("searchterm");
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    }, [searchTerm]);

    useEffect(() => {
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("tabkey", tabIdx[value]);
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    }, [value]);

    const handleChange = (event: SyntheticEvent, idx: number) => {
        setValue(idx);
        setPage(1);
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("page", "1");
        searchParams.set("tabkey", tabIdx[idx]);
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    };

    return (
        <>
            <div className={`${Styles.holderTabsAndFind}`}>
                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" textColor="primary" indicatorColor="primary" >
                    <Tab value={0} label={translator.decode("stats.connexions")} />
                    <Tab value={1} label={translator.decode("stats.seenCars")} />
                    <Tab value={2} label={translator.decode("stats.offers")} />
                </Tabs>
            {
                value !== 3 ?
                <FindUserAdmin adminOpt={value === 0 ? true : false} withAdmin={withAdmin} setWithAdmin={setWithAdmin} setUserID={setUserID} setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
                :null
            }
            </div>
            <CustomTabPanel key={`tabPanel-${0}`} value={value} index={0} idlabel={""} aria={""} >
                <ConnexionComponent userID={userID} displayName={true} withAdmin={withAdmin} page={page} orderby={orderBy} order={order} setOrder={setOrder} setOrderBy={setOrderBy} showTitle={false}/>
            </CustomTabPanel>
            <CustomTabPanel key={`tabPanel-${1}`} value={value} index={1} idlabel={""} aria={""} >
                <SeenCarComponent userID={userID} orderby={orderBy} order={order} setOrder={setOrder} setOrderBy={setOrderBy} showTimeFilter={true} />
            </CustomTabPanel>
            <CustomTabPanel key={`tabPanel-${2}`} value={value} index={2} idlabel={""} aria={""} >
                <OfferStatsComponent updateURL={true} page={page} userID={userID} orderby={orderBy} order={order} setOrder={setOrder} setOrderBy={setOrderBy} showTimeFilter={true} />
            </CustomTabPanel>
        </>
    )
}

export default Stats;
